import { customsInstructionApis } from '@apis/customsInstructionApis';
import { bookingInquiryApis, dashboardBookingInquiryApis } from '@apis/next/bookingInquiryApis';
import { useMutation } from '@hooks/useMutation';
import { AdminPatchCustomsInstruction } from '@models/CustomsInstruction';
import { useQueryClient } from '@tanstack/react-query';
import { FormError } from '@utils/errors';

export const usePatchCustomsInstruction = (d2d_no: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: AdminPatchCustomsInstruction) => {
      const response = await customsInstructionApis.patch(
        '/dashboard/customs-instruction/{d2d_no}/',
        {
          path: { d2d_no },
          body,
        },
      );

      if (response[400]) {
        throw new FormError('PatchCustomsInstructionError', response[400]);
      }

      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['/dashbaord/customs-instruction/', d2d_no]);
        queryClient.invalidateQueries(['/customs-instruction/', d2d_no]);
        queryClient.invalidateQueries(
          dashboardBookingInquiryApis.getKeyByPath(
            'get',
            '/dashboard/booking-inquiry/:d2d_no/status-flows',
          ),
        );
        queryClient.invalidateQueries(
          bookingInquiryApis.getKeyByPath('get', '/booking-inquiry/:d2d_no/status-flows'),
        );
      },
    },
  );
};
